export const PUSH_PROMPT_SEEN_KEY = 'sporto_push_prompt_seen';

export function hasSeenPushPrompt(): boolean {
  if (typeof window === 'undefined' || !window.localStorage) {
    return false;
  }
  return localStorage.getItem(PUSH_PROMPT_SEEN_KEY) === '1';
}

export function markPushPromptSeen(): void {
  if (typeof window === 'undefined' || !window.localStorage) {
    return;
  }
  localStorage.setItem(PUSH_PROMPT_SEEN_KEY, '1');
}
